var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{attrs:{"size":"60","width":"3","color":"primary","indeterminate":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }